import * as React from 'react';
import { createRendererWithUniDriver } from '../../test/utils';
import { calendarCellDriverFactory } from './CalendarCell.driver';
import { CalendarCell, CalendarCellAlignment, CalendarCellTimes } from '.';

const defProps = {
  title: '22',
};

describe('CalendarCell', () => {
  const createDriver = createRendererWithUniDriver(calendarCellDriverFactory);

  it('should render', async () => {
    const { driver } = createDriver(<CalendarCell {...defProps} />);
    expect(await driver.exists()).toBe(true);
  });

  it('should show streched state', async () => {
    const { driver } = createDriver(<CalendarCell stretchable {...defProps} />);

    expect(await driver.stretcheable()).toBeTruthy();
  });

  it('should show past date state', async () => {
    const { driver } = createDriver(
      <CalendarCell timeType={CalendarCellTimes.pastDate} {...defProps} />,
    );

    expect(await driver.hasTimeType(CalendarCellTimes.pastDate)).toBeTruthy();
  });

  it('should show today state', async () => {
    const { driver } = createDriver(
      <CalendarCell timeType={CalendarCellTimes.today} {...defProps} />,
    );

    expect(await driver.hasTimeType(CalendarCellTimes.today)).toBeTruthy();
  });

  it('should show future date state', async () => {
    const { driver } = createDriver(
      <CalendarCell timeType={CalendarCellTimes.futureDate} {...defProps} />,
    );

    expect(await driver.hasTimeType(CalendarCellTimes.futureDate)).toBeTruthy();
  });

  it('should show current state', async () => {
    const { driver } = createDriver(<CalendarCell current {...defProps} />);

    expect(await driver.hasCurrent()).toBeTruthy();
  });

  it('should show right alignment state', async () => {
    const mockAlignment = CalendarCellAlignment.right;
    const { driver } = createDriver(
      <CalendarCell alignment={mockAlignment} {...defProps} />,
    );

    expect(await driver.hasRightAlignment(mockAlignment)).toBeTruthy();
  });
});
